<template>
    <div class="card mb-4">
        <div class="card-header d-flex flex-column flex-sm-row align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                class="bi bi-building" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                    d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694L1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z" />
                <path
                    d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z" />
            </svg>
            Detalles del establecimiento
            <div class="icons-actions ml-auto">
                <div class="accion-gallery">
                    <img class="mr-2" :src="require('@/assets/css/img/icon-gallery.svg')" alt=""/>
                    <!-- <img class="mr-2" src="img/icon-gallery.svg" alt="" data-toggle="tooltip" data-placement="top" title="" data-original-title="Ver galería de imágenes"> -->
                    <b-btn size="sm" class="btn btn-outline-primary" @click="imgs=!imgs">{{ btn_info }}</b-btn>
                    <b-btn size="sm" class="btn btn-outline-primary" @click="precios">precios</b-btn>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="box mb-4">
                <div v-if="imgs" class="box-header d-flex flex-column flex-md-row p-2">
                    <hotelImagenes/>
                </div>

                <!-- {{ hotel }} -->
                <div v-else class="box-header d-flex flex-column flex-md-row p-2">

                    <img :src="imgUrl" :alt="hotel.alias" height="100"/>
                    <!-- <img src="img/img-hotel.jpg" alt="" width="120" height="90"> -->

                    <div class="box-header-location">
                        <h4 class="box-header--title">{{ H.name }} {{ H.cat }}</h4>
                        <p>{{ H.dir }} - {{ H.pob }} - {{ H.pro }}</p>
                        <p>Teléfonos: {{ H.tfn1 }} - {{ H.tfn2 }}</p>
                    </div>
                </div>

                <div class="box-content p-3">
                    <p v-html="hotel.des1"/>

                    <p><strong>DIRECCIÓN:</strong></p> {{ hotel.dir }} <br>
                    <small> {{ hotel.pob }} {{hotel.pro}} </small>

                </div>
            </div>

        </div>
        <div class="card-footer">
            <p class="pl-3">Para acceso a Solicitudes ADJUDICADAS o en Reserva vea Menú
                Reservas.</p>
        </div>

    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

import hotelImagenes from '@/components/hotel-imagenes.vue'

export default {
    name: 'hotel-info',
    components: {
        //publicidad,
        hotelImagenes,
    },
    props: {
        hotel: { type:Object, default: null},
        imgs: { type:Boolean, default: false}
    },
    data() {
        return {
            submitted: false,
            message: 'Error',

            //imgs: false,
        };
    },
    computed: {
        ...mapState(['auth','errores']),
        ...mapState('G',['url']),

        H() {
            if (this.hotel==null) return { id:0,name:'Hotel No existe'};
            return this.hotel;
        },

        imgUrl(){
            //const url = window.URL.createObjectURL(new Blob(this.item.image.data));

            ////?w= time | bd | tabla | id | tp | idp | 0 � nada = imagen, nombre_campo
            let url="https://iberopa.com/_abk/lib/imagendb.php?w=13|vc_telefonica|hoteles_img|||"+this.hotel.id;
            console.log(url);
            return url;

        },

        btn_info() {
            return (this.imgs ? 'Información' : 'Imágenes');
        },

        cta() {
            return this.auth.user;
        },
        admon() {
            return (this.cta.dep=='ADMON');
        },
        chk_selected() {
            return this.submitted && !this.reg.chk;
        }
    },

    watch: {
        hotel(val) {
            console.log('watch',val.id,this.H.id);
            if (val.id!=this.H.id) {
                this.imgs=false;
            }


        },
    },

    methods: {
        ...mapMutations(['loading','alerta','modal','showModal']),
        ...mapActions(['exec']),

        submit(evt) {
            evt.preventDefault();

            //controlar errores
            this.submitted=true;
            //enviar
            this.enviar();
        },

        precios() {
            this.$bvModal.show("modal_hotelPrecios");
        },
        imagenes() {
            this.$bvModal.show("modal_hotelImagenes");
        },

    },
}
</script>
